export const throttleTimer = {

    data() {
        return {

            throttleSecondsRemaining: 0,
            throttleError: '',
            throttleTimer: null
        }
    },

    methods: {
        startThrottleTimer(callback, seconds = 60) {

            this.throttleSecondsRemaining = seconds;
            this.updateThrottleError();

            if (!this.throttleTimer) {
                this.throttleTimer = setInterval(() => {

                    this.updateThrottleError();
                    this.throttleSecondsRemaining--;

                    if (this.throttleSecondsRemaining == 0) {
                        this.throttleError = '';
                        this.throttleTimer = null;
                        clearInterval(this.throttleTimer);
                        callback();
                    }
                }, 1000);
            }
        },

        updateThrottleError() {
            this.throttleError = 'Too many attempts! Re-enabling in ' +
                this.throttleSecondsRemaining + ' seconds...';
        }
    },
};

